import { render } from "./MakeOrder.vue?vue&type=template&id=36c9aecb&scoped=true"
import script from "./MakeOrder.vue?vue&type=script&lang=js"
export * from "./MakeOrder.vue?vue&type=script&lang=js"

import "./MakeOrder.vue?vue&type=style&index=0&id=36c9aecb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c9aecb"]])

export default __exports__